import type {
	OrderDetailResponseDto,
	OrderExaminationResponseDto,
} from "Infrastructure/Api/Api";
import { EditExaminationForm } from "Order/Modules/Examination/Components/Form/EditOrderExaminationForm";

type OrderExaminationTabProps = {
	orderExamination?: OrderExaminationResponseDto;
	order: OrderDetailResponseDto;
};

export function OrderExaminationTab({
	orderExamination,
	order,
}: OrderExaminationTabProps) {
	return orderExamination ? (
		<EditExaminationForm orderExamination={orderExamination} order={order} />
	) : null;
}
